import { apiClient } from './axiosInstance';
import { IClientInfo } from 'features/clientInfo/clientInfoTypes';

export const fetchOrganizationClientInfo = async (clientId: string) => {
  return await apiClient.get(`clients/${clientId}`);
};

export const updateClientInfo = async (data: IClientInfo) => {
  return await apiClient.put(`clients/${data.id}`, { ...data });
};
